import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const mercadolibreRoot = (state: State) => state.mercadolibre;

export const settingSelector = createSelector(
  mercadolibreRoot,
  (mercadolibre) => mercadolibre.settings
);
